require('./availability-container.scss')

module.exports = {
  template: require('./availability-container.pug')()
  controller: require('./availability-container.ctrl')
  bindings:
    salon: '<'
}
